import React, { Component } from "react";
import { Form, Row, Col, Button, Modal } from "antd";
import { RightOutlined, DeleteOutlined } from "@ant-design/icons";
import update from "immer";

import { AddNewCustomer } from "./add-customer/add-customer";
import { AddNewAdmin } from "./add-admin/add-admin";
import { AddSubUser } from "./add-sub-user/add-sub-user";
import { submit, userConvert } from "./user-event";
import { CUSTOMER_CODE } from "../../../common/utils/static-data";
import { BottomButton } from "./bottom-button/bottom-button";
import { apiCustomer } from "../../../api/api-customer";
import { alert } from "../../../common/utils/alert";

const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
};

const initialValues = {
  customer_type: "CT002",
  card_type: 1,
  accountStatus: 0,
  password: "Cus-0000",
};
//Sử dụng Ref cho vấn đề cập nhật lại UI trong các Component con
export class AddUser extends Component {
  userParam = {};

  async componentDidMount() {
    // this.adminUser.setState({ iso2: 'vn'})
    const result = await apiCustomer.getEnterpriseCustomerName();
    if (result.status === "success") {
      if (this.state.typeOption === "create_new") {
        this.form.setFieldsValue({
          signinName: result.data,
        });
      }
    } else {
      alert("error", result.status);
    }
  }
  state = {
    enterprise: true,
    editable: true,
    editPage: false,
    typeOption: "create_new",
    cardType: 1,
    checkAccountStatus: true,
    checkEditPass: false,
    isInContract: false,
    defaultData: null,
  };

  submit = async () => {
    submit(this);
  };

  onChangeForm = (feild, value) => {
    this.form.setFieldsValue({
      [feild]: value,
    });
  };

  onChangeFormValues = (values) => {
    this.form.setFieldsValue({
      ...values,
    });
  };

  getCustomerType = () => {
    if (!this.form) {
      return CUSTOMER_CODE.enterprise;
    }
    return this.form.getFieldValue("customer_type");
  };

  setEnterprise = async (enterprise) => {
    this.setState({ enterprise });
    if (enterprise) {
      const result = await apiCustomer.getEnterpriseCustomerName();
      if (result.status === "success") {
        if (this.state.typeOption === "create_new") {
          this.form.setFieldsValue({
            signinName: result.data,
          });
        }
      } else {
        alert("error", result.status);
      }
    } else {
      const result = await apiCustomer.getIndividualCustomerName();
      if (result.status === "success") {
        if (this.state.typeOption === "create_new") {
          this.form.setFieldsValue({
            signinName: result.data,
          });
        }
      } else {
        alert("error", result.status);
      }
    }
  };

  setAccountStatus = (checkAccountStatus) => {
    this.setState({ checkAccountStatus });
  };

  goToDetailUser = () => {
    if (this.userParam) this.updateFormUser(this.userParam);
  };

  updateFormUser = async (user) => {
    this.userParam = user;
    this.setState({
      editable: false,
      typeOption: "show_detail",
      editPage: true,
      defaultData: user,
    });
    await userConvert(user, this);
  };

  enableEdit = () => {
    this.setState({
      editable: true,
      typeOption: "edit",
      checkAccountStatus:
        this.form.getFieldValue("accountStatus") === 0 ? true : false,
    });
  };

  cancelEdit = () => {
    this.setState({ editable: false, typeOption: "show_detail" }, () => {
      this.updateFormUser(this.state.defaultData);
      this.form.setFieldsValue({
        password: initialValues.password,
      });
    });
  };

  handleDelAdmin = () => {
    const title =
      this.userParam.customer_type && this.userParam.customer_type === "CT002"
        ? "Xóa admin"
        : "Xóa khách hàng";
    Modal.confirm({
      title: title,
      icon: null,
      content: `Bạn có chắc chắn muốn xóa ${
        this.userParam.customer_type && this.userParam.customer_type === "CT002"
          ? "admin"
          : "khách hàng"
      } này không? ${
        this.userParam.customer_type && this.userParam.customer_type === "CT002"
          ? "Nếu xóa những user thuộc quản lý của admin cũng bị xóa"
          : ""
      } `,
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      onOk: async () => {
        const { close } = this.props;
        if (
          this.userParam.customer_type &&
          this.userParam.customer_type === "CT002"
        ) {
          const result = await apiCustomer.deleteCustomerEnterprise(
            this.userParam.member_customer_id
          );
          if (result.status === "success") {
            alert("success", "Xóa admin thành công!");
            close();
          } else {
            alert("error", result.data.message);
          }
        } else {
          const result = await apiCustomer.deleteCustomerPersonal(
            this.userParam.customer_id
          );
          if (result.status === "success") {
            alert("success", "Xóa khách hàng cá nhân thành công!");
            close();
          } else {
            alert("error", result.data.message);
          }
        }
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  validateForm = () => {
    if (this.form) {
      const fieldsObject = this.form.getFieldsError();
      const fieldsErros = fieldsObject
        .filter((value) => {
          if (value.errors.length > 0) {
            return true;
          }
        })
        .map((value) => {
          if (value.name.length > 0) {
            return value.name[0];
          }
        });
      this.form.validateFields(fieldsErros);
    }
  };

  checkEditPass = (v) => {
    if (!this.state.checkEditPass) {
      this.setState({ checkEditPass: true });
      this.form.setFieldsValue({
        password: "",
      });
    } else {
      this.form.setFieldsValue({
        password: v,
      });
    }
  };

  addUserSuggest = async () => {
    const { users } = this.form.getFieldsValue();
    const allUsers = users.filter((i) => !!i);

    if (allUsers.length > 0) {
      const oldUser = allUsers.filter((i) => i.edit);
      const newUser = allUsers.filter((i) => !i.edit);

      const newUsers = await Promise.all(
        newUser.map((item, index) =>
          apiCustomer.getMemberSuggest({ count: index + 1 }).then((res) => ({
            ...item,
            username: res.data,
            password: "Avis@qwer2020",
          }))
        )
      );

      this.form.setFieldsValue({
        users: [...oldUser, ...newUsers],
      });
    }
  };

  updateFieldUser = (value, index) => {
    const { users } = this.form.getFieldsValue();
    if (!!users && users.length > 0) {
      const newUsers = update(users, (darf) => {
        darf[index] = { ...darf[index], ...value };
      });

      this.form.setFieldsValue({
        users: newUsers,
      });
    }
  };

  render() {
    const {
      enterprise,
      editable,
      editPage,
      typeOption,
      checkAccountStatus,
      isInContract,
    } = this.state;
    return (
      <div className="add-user">
        <div className="add-new-user-title">
          <span onClick={this.props.close}>
            Danh sách khách hàng
            <RightOutlined style={{ margin: "0px 7px" }} />
          </span>
          {typeOption === "create_new"
            ? "Thêm khách hàng mới"
            : typeOption === "show_detail"
            ? "Chi tiết khách hàng"
            : "Chỉnh sửa khách hàng"}
        </div>
        <Form
          style={{ padding: "0px 10px" }}
          initialValues={initialValues}
          scrollToFirstError
          ref={(ref) => (this.form = ref)}
          {...layout}
        >
          <Row gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <AddNewCustomer
                editable={editable}
                editPage={editPage}
                enterprise={enterprise}
                setEnterprise={this.setEnterprise}
                ref={(ref) => (this.newCustomer = ref)}
                validate={this.validateForm}
                onChangeForm={this.onChangeForm}
                onChangeFormValues={this.onChangeFormValues}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <div style={{ position: "relative" }}>
                <AddNewAdmin
                  editable={editable}
                  enterprise={enterprise}
                  setAccountStatus={this.setAccountStatus}
                  checkEditPass={this.checkEditPass}
                  getCustomerType={this.getCustomerType}
                  onChangeFormValues={this.onChangeFormValues}
                  ref={(ref) => (this.adminUser = ref)}
                  typeOption={typeOption}
                  validate={this.validateForm}
                />
              </div>
            </Col>
          </Row>
          {typeOption === "edit" ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Button
                disabled={!editable || isInContract}
                type="danger"
                className={isInContract ? "del-admin disable-del" : "del-admin"}
                icon={<DeleteOutlined />}
                onClick={this.handleDelAdmin}
              >
                {" "}
                {this.userParam.customer_type &&
                this.userParam.customer_type === "CT002"
                  ? "Xóa admin"
                  : "Xóa khách hàng"}{" "}
              </Button>
            </div>
          ) : null}
          {enterprise && (
            <>
              <div className="add-new-user-title sub-user-title">
                Thêm user mới
              </div>
              <AddSubUser
                updateFieldUser={this.updateFieldUser}
                userParam={this.userParam}
                addUserSuggest={this.addUserSuggest}
                disable={checkAccountStatus}
                editable={editable}
                ref={(ref) => (this.addNewUser = ref)}
                typeOption={typeOption}
              />
            </>
          )}
        </Form>
        {/* <div className="button-container-add-user">
          <Button onClick={() => this.props.close()} className="cancel-btn">Hủy</Button>
          <Button onClick={this.submit} className="add-btn" close={this.props.close}>Thêm khách hàng</Button>
        </div> */}
        <BottomButton
          typeOption={typeOption}
          enableEdit={this.enableEdit}
          submit={this.submit}
          cancelEdit={this.cancelEdit}
          close={this.props.close}
          goToDetailUser={this.goToDetailUser}
          userParam={this.userParam}
        />
      </div>
    );
  }
}
